import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ResetPasswordForm from "../../components/forms/ResetPasswordForm";
import { acceptInvitation } from "../../api/endpoints/Invitations/acceptInvitation";
import { expiredInvitation } from "../../api/endpoints/Invitations/invitations";
import { ApiResponse } from "../../api/apiResponse";
import StudentModel from "../../api/models/StudentModel";
import { login } from "../../api/endpoints/auth";
import {
  clearAuthCredentials,
  setAuthCredentialsFromApiResponse,
} from "../../api/helpers/authHelpers";
import TutorModel from "../../api/models/TutorModel";
import LoadingSpinner, { FullSpinner } from "../../components/LoadingSpinner";
import LiaisonModel from "../../api/models/LiaisonModel";
import ContainerMd from "../../components/Layouts/ContainerMd";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import { makeApiRequest } from "../../helpers";
import SupervisorModel from "../../api/models/SupervisorModel";

export default function SetPasswordPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [invitationStatusLoading, setInvitationStatusLoading] =
    useState<boolean>(true);
  const Context = useAuth();

  const navigate = useNavigate();
  const LocalBasePath = "page.student.setPassword";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  let { id } = useParams();
  const invitationStatus = () => {
    makeApiRequest(
      () => expiredInvitation(id),
      (response: ApiResponse) => {
        const { is_expired } = response?.data;
        if (is_expired) {
          navigate(`/expired/${id}`);
        } else {
          setInvitationStatusLoading(false);
        }
      }
    );
  };
  const onPressSetPassword = async (data: any) => {
    try {
      setIsLoading(true);
      const acceptResponse: ApiResponse = await acceptInvitation(
        id!,
        data.confirmPassword
      );
      if (acceptResponse.isSuccess) {
        clearAuthCredentials();
        let user: StudentModel | TutorModel | LiaisonModel | SupervisorModel;
        let responseJson: { object_type: string } = acceptResponse.data as {
          object_type: string;
        };
        if (responseJson.object_type === "Student") {
          user = StudentModel.fromApiResponse(acceptResponse.data);
        } else if (responseJson.object_type === "Tutor") {
          user = TutorModel.fromApiResponse(acceptResponse.data);
        } else if (responseJson.object_type === "Supervisor") {
          user = SupervisorModel.fromApiResponse(acceptResponse.data);
        } else {
          user = LiaisonModel.fromApiResponse(acceptResponse.data);
        }

        const response: ApiResponse = await login(
          user.account?.email!,
          data.confirmPassword
        );
        if (response.isSuccess) {
          setAuthCredentialsFromApiResponse(response);
          await Context?.fetchCurrentUser();
          if (user.object_type === "Candidate") {
            navigate("/");
          } else {
            navigate(
              `/${user.object_type?.toLocaleLowerCase()}/fill-account-info`
            );
          }
        } else {
          acceptResponse.errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage);
          });
        }
      } else {
        toast.error(t("emailAlreadyExists"));
      }
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    invitationStatus();
  }, [id]);
  const Spinner = () => {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <LoadingSpinner size={16} />
      </div>
    );
  };
  if (invitationStatusLoading) {
    return (
      <div className="h-screen">
        <FullSpinner size={40} />
      </div>
    );
  }

  return (
    <ContainerMd>
      <ResetPasswordForm
        title={t("title", { name: "" })}
        subtitle={t("subtitle")}
        actionTitle={!!isLoading ? <Spinner /> : t("actionTitle")}
        onReset={onPressSetPassword}
      />
    </ContainerMd>
  );
}
